<template>
	<div class="schedule-component">
		<div class="title-block">
			<div class="mb-2">
				<label class="page-label">Расписание</label>
			</div>

			<div class="tabs">
				<div class="tabs__log-ctrls">
					<button @click="setSelectedTabId"
						:class="{'selected': selectedTabId === 'softwareUpdateScheduleComponent'}"
						id="softwareUpdateScheduleComponent"
						class="reset-btn tabs__log-ctrl">
						Обновления ПО
					</button>
					<button @click="setSelectedTabId"
						:class="{'selected': selectedTabId === 'contentUpdateScheduleComponent'}"
						id="contentUpdateScheduleComponent"
						class="reset-btn tabs__log-ctrl">
						Обновления контента
					</button>
				</div>
			</div>

            <div class="title-block__btns">
                <a class="title-block__btn btn-add btn-primary btn">Добавить</a>

                <a :class="selectedRows.length > 0 ? 'title-block__btn btn-primary-reversed btn' : 'title-block__btn btn-primary-reversed disabled btn'" href="#">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.6667 2.5V5.83333C11.6667 6.05435 11.7545 6.26631 11.9108 6.42259C12.0671 6.57887 12.2791 6.66667 12.5001 6.66667H15.8334M11.6667 2.5H5.83341C5.39139 2.5 4.96746 2.67559 4.6549 2.98816C4.34234 3.30072 4.16675 3.72464 4.16675 4.16667V15.8333C4.16675 16.2754 4.34234 16.6993 4.6549 17.0118C4.96746 17.3244 5.39139 17.5 5.83341 17.5H14.1667C14.6088 17.5 15.0327 17.3244 15.3453 17.0118C15.6578 16.6993 15.8334 16.2754 15.8334 15.8333V6.66667M11.6667 2.5L15.8334 6.66667M10.0001 14.1667V9.16667M10.0001 14.1667L7.91675 12.0833M10.0001 14.1667L12.0834 12.0833" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Выгрузить</span>
                </a>

                <a :class="selectedRows.length > 0 ? 'title-block__btn btn-primary-reversed btn' : 'title-block__btn btn-primary-reversed disabled btn'" href="#">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_4147_37594)">
                            <path d="M3.33331 5.83398H16.6666" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.33331 9.16699V14.167" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.6667 9.16699V14.167" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.16663 5.83398L4.99996 15.834C4.99996 16.276 5.17555 16.6999 5.48811 17.0125C5.80068 17.3251 6.2246 17.5007 6.66663 17.5007H13.3333C13.7753 17.5007 14.1992 17.3251 14.5118 17.0125C14.8244 16.6999 15 16.276 15 15.834L15.8333 5.83398" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_4147_37594">
                                <rect width="20" height="20" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <span>Удалить</span>
                </a>
            </div>
		</div>
	</div>

	<SoftwareUpdateScheduleComponent
		v-if="selectedTabId === 'softwareUpdateScheduleComponent'"
		@selectRow="handleSelectedRows"
	/>

	<ContentUpdateScheduleComponent
		v-if="selectedTabId === 'contentUpdateScheduleComponent'"
		@selectRow="handleSelectedRows"
	/>
</template>

<script>
import ContentUpdateScheduleComponent from './ContentUpdateScheduleComponent.vue';
import SoftwareUpdateScheduleComponent from './SoftwareUpdateScheduleComponent.vue';

export default {
    name: 'ScheduleComponent',

	components: {
		SoftwareUpdateScheduleComponent,
		ContentUpdateScheduleComponent
	},

	data() {
		return {
			selectedTabId: 'softwareUpdateScheduleComponent',
			selectedRows: []
		}
	},

	methods: {
		setSelectedTabId(e) {
			this.selectedTabId = e.target.id;
			this.selectedRows = [];
		},
		handleSelectedRows(selectedRows) {
			this.selectedRows = selectedRows;
		}
	}
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
        &__btns {
            margin-left: auto;
            display: flex;
            gap: 6px;
        }
	}
	.page-label {
		font-size: 18px;
		font-weight: 600;
	}
</style>